import { type FC } from 'react';

import {
  Layout as GenericLayout,
  type LayoutProps as GenericLayoutProps,
} from '@craft/ui/components/layout';

import { CraftSideNav } from '@/src/components/molecules/CraftSideNav';
import { CraftHeaderBar } from '@/src/components/molecules/navigation/CraftHeaderBar';

export interface LayoutProps extends Omit<GenericLayoutProps, 'header' | 'sidebar'> {}

export const Layout: FC<LayoutProps> = props => {
  if (props.isSidebarVisible === false && props.isHeaderVisible === false) {
    return <GenericLayout {...props} />;
  }
  return (
    <GenericLayout
      {...props}
      header={<CraftHeaderBar />}
      sidebar={
        <CraftSideNav
          flexShrink={0}
          sx={t => ({ backgroundColor: t.palette.other.sideNavBgColor })}
          width='105px'
        />
      }
    />
  );
};
